export const SHOW_UPGRADE_MODAL = 'ui/SHOW_UPGRADE_MODAL';

export const PER_PAGE = 12;

export const SHOW_MODAL = 'ui/SHOW_MODAL';
export const HIDE_MODAL = 'ui/HIDE_MODAL';
export const LOADER = 'ui/SET_LOADER';
